import { useFormContext } from 'react-hook-form';
import { useFlowsDispatch } from '../../../../../../../common/src/utils/globalVariables';
import useFlowsHelper from '../../../../../hooks/useFlowsHelper';
import { updateAnswers } from '../../../../../store/redux/slices/flowsSlice';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';

const useUpdateItemAmount = (
  question: FlowsQuestion,
): ((amount: number) => void) => {
  const flowsDispatch = useFlowsDispatch();
  const { getGroupByQuestionId } = useFlowsHelper();
  const { setValue } = useFormContext();

  const questionGroup = getGroupByQuestionId(question.id);

  return (amount: number) => {
    setValue(question.id, amount);
    flowsDispatch(
      updateAnswers({
        id: question.id,
        answer: amount,
        groupId: questionGroup.id,
        tag: questionGroup.tag,
      }),
    );
  };
};

export default useUpdateItemAmount;
